import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'
import SelectIcon from 'icons/input.svg'

export const Wrap = styled.div`
  width: 100%;
`

export const Title = styled.div`
  color: var(--light);

  margin-bottom: ${calculateResponsiveSize(3)};
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 700;
  line-height: ${calculateResponsiveSize(16)};
  letter-spacing: ${calculateResponsiveSize(2)};
  text-align: left;

  text-align: left;
  text-transform: uppercase;
  &.error {
    color: #ff0c00;
  }
  ${mediaMax('mobile')} {
    font-family: Basis Grotesque Pro;
    font-size: ${calculateMobileResponsiveSize(10)};
    font-weight: 700;
    line-height: ${calculateMobileResponsiveSize(16)};
    letter-spacing: ${calculateMobileResponsiveSize(2)};
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
`
export const InputField = styled.input`
  -webkit-appearance: none;
  border-radius: 0;
  padding: ${calculateResponsiveSize(0)} 0;
  border: none;
  border-bottom: 1px solid var(--light);
  background: none;
  width: 100%;
  outline: none;

  font-family: 'Basis Grotesque';
  font-size: ${calculateResponsiveSize(12)};
  font-weight: 400;
  line-height: ${calculateResponsiveSize(19.2)};
  text-align: left;

  color: #ededed80;

  &.error {
    border-bottom: 1px solid #ff0c00;
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px var(--black) inset !important;
    -webkit-text-fill-color: var(--light);
  }
  position: relative;
  .arrow & {
    background-image: url(${SelectIcon});
    background-position: right 80%;
    background-repeat: no-repeat;
    background-size: ${calculateResponsiveSize(6)} ${calculateResponsiveSize(6)};
    padding-right: ${calculateResponsiveSize(15)};
  }

  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(12)};
    line-height: ${calculateMobileResponsiveSize(14)};
    padding: ${calculateMobileResponsiveSize(6)} 0;
    .arrow & {
      background-size: ${calculateMobileResponsiveSize(7)}
        ${calculateMobileResponsiveSize(7)};
      padding-right: ${calculateMobileResponsiveSize(9)};
    }
  }
`
